import React from "react";
import {
  AreaChart,
  linearGradient,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  BarChart,
  Bar,
  LabelList,
} from "recharts";
import clsx from "clsx";
import useInterval from "@rooks/use-interval";
import { useEffect, useState, useContext } from "react";
import { ConfigContext } from "../../../contexts/ConfigContext";

import axios from "../../../api/axios";
import useConfig from "../../../hooks/useConfig";
import useAuth from "../../../hooks/authenticate/useAuth";

var request_updateTimelineData_safe = true;

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function findHourData(timeline, hour) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return timeline[i];
    }
  }
  return -1;
}

function margeSameHours(timeline) {
  let temp = [];
  for (let i = 0; i < timeline.length; i++) {
    let currentChecker = timeline[i];
    for (let j = i + 1; j < timeline.length; j++) {
      if (
        parseInt(timeline[i]["hour"].split(":")[0]) ===
        parseInt(timeline[j]["hour"].split(":")[0])
      ) {
        currentChecker["inCount"] += timeline[j]["inCount"];
        currentChecker["outCount"] += timeline[j]["outCount"];
        currentChecker["total"] += timeline[j]["total"];
      }
    }
    temp.push(currentChecker);
  }

  return temp;
}

function fillLine(timeline) {
  let temp = [];

  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  for (let i = 0; i <= new Date().getHours(); i++) {
    let hour = i < 10 ? `0${i}:00` : `${i}:00`;
    let res = findHourData(timeline, hour);

    if (res !== -1) {
      temp.push(res);
    } else {
      temp.push({
        hour: hour,
        inCount: 0,
        outCount: 0,
      });
    }
  }
  return temp;
}

const CustomTooltips = ({ active, payload, label }) => {
  // console.log(`payload ${payload} `);

  if (active && payload && payload.length) {
    if (
      payload[0] &&
      payload[1] &&
      payload[0].value === 0 &&
      payload[1].value === 0
    ) {
      return null;
    } else if (payload[0] && payload[0].value === 0) {
      return null;
    } else if (payload[1] && payload[1].value === 0) {
      return null;
    }
    return (
      <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
        {
          <p>{`${payload[0].payload["hour"]}-${
            payload[0].payload["hour"].split(":")[0]
          }:59 `}</p>
        }
        {payload[0] && (
          <p
            className={clsx({
              "text-blue-500": payload[0].dataKey === "inCount",
            })}
          >{`In Count : ${payload[0].value.toLocaleString()}`}</p>
        )}
        {/* {payload[1] && (
            <p
              className={clsx({
                "text-green-500": payload[1].dataKey === "outCount",
              })}
            >{`Out Count : ${payload[1].value.toLocaleString()}`}</p>
          )} */}

        {/* <p className="text-gray-400">Total: {totalVisits.toLocaleString()}</p> */}
      </div>
    );
  }

  return null;
};

const CreativeInOut = () => {
  const [timelineData, setTimelineData] = useState([]);
  const { config } = useConfig();
  const { auth } = useAuth();
  const [totalInCount, setTotalInCount] = useState(0);
  const [totalCurrentCount, setTotalCurrentCount] = useState(0);
  const [devices, setDevices] = useState(new Map());
  const [device, setDevice] = useState("");

  const [finishSetup, setFinishSetup] = useState(false);

  const [loading, setLoading] = useState(true);

  function initDevices() {
    let devices = new Map();
    config.areas[0]["devices"].forEach((device, index) => {
      setDevice((prev) => device.deviceId);
      devices.set(device.deviceId, { azimuth: device.azimuth, index: index });
    });
    setDevices((prev) => devices);
  }

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/direction/hour?token=${
          auth.token
        }&day=${new Date().getUTCDate()}&month=${new Date().getUTCMonth() + 1}`
      )
      .then((res) => {
        let timeline = [];
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (
              parseInt(res.data[i][j]["hour"].split(":")[0]) <=
              new Date().getHours()
            ) {
              if (devices.has(res.data[i][j]["sensor"])) {
                let toNorthEastCount = res.data[i][j]["toNorthEastCount"];
                let toNorthWestCount = res.data[i][j]["toNorthWestCount"];
                let toSouthEastCount = res.data[i][j]["toSouthEastCount"];
                let toSouthWestCount = res.data[i][j]["toSouthWestCount"];
                let inCount = 0;
                let outCount = 0;
                if (res.data[i][j]["sensor"] === "600a0c2a69e63586") {
                  inCount = toNorthWestCount + toNorthEastCount;
                  outCount = toSouthWestCount + toSouthEastCount;
                } else {
                  inCount = toNorthWestCount + toSouthWestCount;
                  outCount = toNorthEastCount + toSouthEastCount;
                }

                let total = inCount + outCount;

                timeline.push({
                  hour: getLocalHour(res.data[i][j]["date"]),
                  inCount: inCount !== undefined ? inCount : 0,
                  outCount: outCount !== undefined ? outCount : 0,
                  total: total !== undefined ? total : 0,
                });
              }
            }
          }
        }
        let totalIn = timeline.reduce((a, b) => a + b["inCount"], 0);
        let totalOut = timeline.reduce((a, b) => a + b["outCount"], 0);

        let current = Math.round(
          totalIn - Math.round(totalIn * 0.1) + Math.random() * 10
        );
        if (current < 0) {
          current = 0;
        }
        setTotalInCount((prev) => totalIn);
        setTotalCurrentCount((prev) => current);
        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        timeline = margeSameHours(timeline);
        timeline = fillLine(timeline);
        setFinishSetup(true);

        setTimelineData((prev) => timeline);
        // setLoading(false);
        // if (totalCountVehicles !== totalVehicles) {
        //   setTotalCountVehicles((prev) => totalVehicles);
        // }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
  }

  useEffect(() => {
    initDevices();
    updateTimelineData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (finishSetup) {
        updateTimelineData();
        setLoading(false);
      } else updateTimelineData();
    },
    10000,
    true
  );

  if (loading) {
    return (
      <div className="bg-gray-300 flex-auto w-full h-full rounded-md overflow-hidden transition-all">
        <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent  animate-slide"></div>
      </div>
    );
  }
  if (device === "600a0c2a69e63586")
    return (
      <div className="w-full h-4/5 flex flex-col justify-center px-6 rounded-2xl mt-20   ">
        <div className="xl:text-5xl 2xl:text-6xl font-sans text-center font-medium text-gray-600">
          Welcome , Shalom
        </div>
        <div className="flex flex-col justify-center justify-items-center ">
          <div className="w-full xl:py-5 2xl:py-10">
            <div className="flex flex-row items-center justify-center">
              <div className="xl:mx-6 xl:text-4xl 2xl:text-7xl border-b-2  2xl:mx-3 w-56 text-eco text-center rounded-2xl shadow-lg">
                {totalInCount}
              </div>
              <div className=" flex justify-items-center pt-5">
                <div className="xl:text-2xl 2xl:text-3xl text-gray-600 text-center align-text-bottom rounded-2xl ">
                  visitors came to meet the Israeli mobility ecosystem today.​
                </div>
              </div>
            </div>

            <div className="w-full py-12">
              <div className="flex flex-row items-center justify-center">
                <div className="xl:text-2xl 2xl:text-3xl pt-5 text-gray-600 text-center align-text-bottom rounded-2xl ">
                  Right now, we have
                </div>
                <div className="xl:text-4xl 2xl:text-7xl border-b-2 mx-3 w-56 text-indigo-600  text-center rounded-2xl shadow-lg ">
                  {totalCurrentCount}
                </div>
                <div className="xl:text-2xl 2xl:text-3xl pt-5 text-gray-600  text-center align-text-bottom rounded-2xl ">
                  visitors doing business inside. GOOD LUCK​
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-full">
          <div className="w-full h-full flex items-center justify-center  content-center ">
            <div className="w-3/5 xl:h-60 2xl:h-72 rounded-xl bg-opacity-80">
              <ResponsiveContainer>
                <BarChart
                  data={timelineData}
                  margin={{ top: 5, right: 12, left: 10, bottom: 14 }}
                >
                  <defs>
                    {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
              <stop offset="100%" stopColor="rgb(156, 163, 175)" />
            </linearGradient> */}
                    <linearGradient id="inCount" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="100%" stopColor=" #00b5b5" opacity={1} />
                    </linearGradient>
                    {/* <linearGradient id="outCount" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="100%"
                  stopColor="rgb(59, 130, 246)"
                  opacity={0.5}
                />
              </linearGradient> */}
                  </defs>
                  <Tooltip
                    coordinate={{ x: 0, y: 0 }}
                    offset={0}
                    allowEscapeViewBox={{ x: false, y: true }}
                    content={<CustomTooltips />}
                  />
                  <XAxis
                    axisLine={false}
                    tick={{ fontSize: "0.8rem" }}
                    interval="preserveStartEnd"
                    height={15}
                    dataKey="hour"
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={true}
                    tick={{ fontSize: "0.8rem" }}
                    width={30}
                    interval="preserveStartEnd"
                    dataKey="total"
                  />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Bar
                    type="natural"
                    dataKey="inCount"
                    stroke="#00b5b5"
                    strokeWidth={2}
                    fillOpacity={1}
                    fill={"url(#inCount)"}
                  >
                    <LabelList
                      dataKey="inCount"
                      fill="#00b5b5"
                      fontSize={"0.6rem"}
                      position={"top"}
                      formatter={(value) =>
                        new Intl.NumberFormat("en").format(value)
                      }
                    ></LabelList>
                  </Bar>
                  {/* <Area
              type="natural"
              dataKey="outCount"
              stroke="rgb(59, 130, 246)"
              strokeWidth={2}
              fillOpacity={0.3}
              fill={"url(#outCount)"}
            /> */}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    );
  else {
    return (
      <div className="w-full h-4/5 flex flex-col justify-center px-6 py-7 rounded-2xl mt-20   ">
        <div className="xl:text-5xl 2xl:text-7xl font-sans text-center font-medium text-gray-600">
          Hi ,
        </div>
        <div className="flex flex-col justify-center justify-items-center ">
          <div className="w-full xl:py-5 2xl:py-20 ">
            <div className="flex flex-row items-center justify-center">
              <div className="xl:-mt-16 xl:-mr-6 xl:mx-6 xl:text-4xl 2xl:text-7xl border-b-2  2xl:mx-0 2xl:-mt-24 2xl:-mr-6 w-56 text-eco text-center rounded-2xl shadow-lg">
                {totalCurrentCount}
              </div>
              <div className=" flex justify-items-center pt-5">
                <br />
                <div className="xl:text-2xl 2xl:text-4xl text-gray-600 text-center align-text-bottom rounded-2xl ">
                  visitors are in this hall to hear more <br />
                  <div className="pt-10 -left-2">
                    about the Israeli smart mobility latest news!​
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-full mt-10">
          <div className="w-full h-full flex items-center justify-center  content-center ">
            <div className="w-3/5 xl:h-60 2xl:h-72 rounded-xl bg-opacity-80">
              <ResponsiveContainer>
                <BarChart
                  data={timelineData}
                  margin={{ top: 5, right: 12, left: 10, bottom: 14 }}
                >
                  <defs>
                    {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="rgb(156, 163, 175)" />
              </linearGradient> */}
                    <linearGradient id="inCount" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="100%" stopColor=" #00b5b5" opacity={1} />
                    </linearGradient>
                    {/* <linearGradient id="outCount" x1="0" y1="0" x2="0" y2="1">
                  <stop
                    offset="100%"
                    stopColor="rgb(59, 130, 246)"
                    opacity={0.5}
                  />
                </linearGradient> */}
                  </defs>
                  <Tooltip
                    coordinate={{ x: 0, y: 0 }}
                    offset={0}
                    allowEscapeViewBox={{ x: false, y: true }}
                    content={<CustomTooltips />}
                  />
                  <XAxis
                    axisLine={false}
                    tick={{ fontSize: "0.8rem" }}
                    interval="preserveStartEnd"
                    height={15}
                    dataKey="hour"
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={true}
                    tick={{ fontSize: "0.8rem" }}
                    width={30}
                    interval="preserveStartEnd"
                    dataKey="total"
                  />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Bar
                    type="natural"
                    dataKey="inCount"
                    stroke="#00b5b5"
                    strokeWidth={2}
                    fillOpacity={1}
                    fill={"url(#inCount)"}
                  >
                    <LabelList
                      dataKey="inCount"
                      fill="#00b5b5"
                      fontSize={"0.6rem"}
                      position={"top"}
                      formatter={(value) =>
                        new Intl.NumberFormat("en").format(value)
                      }
                    ></LabelList>
                  </Bar>
                  {/* <Area
                type="natural"
                dataKey="outCount"
                stroke="rgb(59, 130, 246)"
                strokeWidth={2}
                fillOpacity={0.3}
                fill={"url(#outCount)"}
              /> */}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default CreativeInOut;
